import { useTranslation } from 'react-i18next';
import { WaitlistForm } from '../components/WaitlistForm';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export function WaitlistPage() {
  const { t } = useTranslation('waitlist');

  return (
    <div className="mx-auto my-[60px] max-w-[520px] px-4">
      <div className="mb-4 flex justify-end">
        <LanguageSwitcher />
      </div>
      <h1>{t('title')}</h1>
      <p className="mb-6 text-brand-muted">
        {t('subtitle')}
      </p>
      <WaitlistForm />
    </div>
  );
}
